import React from 'react';
import { useLocation } from 'react-router-dom';
import PerfilForm from '../components/PerfilForm';
import { Container } from '@mui/material';

const PerfilPage = () => {
  const location = useLocation();
  const  {customer} = location.state || {};

  return (
    <Container maxWidth="lg">
      <PerfilForm customer={customer} />
    </Container>
  );
};

export default PerfilPage;